<template>
  <div class="b-best-sellers">
    <div class="b-best-sellers__background">
      <SlickCarousel
        v-if="images"
        ref="slick"
        :key="'key-' + slickKey"
        class="b-best-sellers__slick"
        :options="slickOptions">
        <div v-for="(image, index) in images" :key="index" class="item">
          <Anchor :item="item.link" :hide-text="true">
            <LazyImage :image="image" />
          </Anchor>
        </div>
      </SlickCarousel>
    </div>
    <div v-if="item.offerText" class="b-best-sellers__offer-text">
      {{ item.offerText }}
    </div>
    <Anchor :item="item.link" :hide-text="true" class="b-best-sellers__body">
      <div class="b-best-sellers__left-side">
        <div v-if="item.thumbImage" class="b-best-sellers__image">
          <img
            v-if="isElectric"
            class="leaf"
            src="/imgs/icons/leaf@2x.png"
            alt="leaf" />
          <LazyImage v-if="item.thumbImage" :image="item.thumbImage" />
        </div>
        <div class="b-best-sellers__header">
          <div class="b-best-sellers__title h4 extrabold">
            {{ item.make }} {{ item.model }}
          </div>
          <div class="b-best-sellers__details">
            <ul>
              <li v-if="item.fuel">
                <span>•&nbsp;&nbsp;{{ item.fuel }}</span>
              </li>
              <li v-if="item.transmissionType">
                <span>•&nbsp;&nbsp;{{ item.transmissionType }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="b-best-sellers__right-side">
        <div class="b-best-sellers__footer">
          <div class="b-best-sellers__totals">
            <div class="b-best-sellers__price-w-vat">
              <div class="bold mb-5">
                <span>{{ dictionary.vehiclePricePrefix }}&nbsp;</span>
                <span class="animate">
                  <em v-if="vatIncluded">{{ item.pricePerMonthInclVat }}</em>
                  <em v-else>{{ item.pricePerMonth }}</em>
                  {{ dictionary.vehiclePriceSuffix }}
                </span>
              </div>

              <div class="form-check form-switch">
                <label
                  class="form-check-label"
                  :style="{ cursor: isPointer }"
                  :for="'vat' + item.id">
                  <span v-if="vatIncluded">
                    {{ dictionary.vehicleVatIncluded }}
                  </span>
                  <span v-else>{{ dictionary.vehicleVatExcluded }}</span>
                </label>
                <input
                  v-if="!isDisabled"
                  :id="'vat' + item.id"
                  v-model="vatIncluded"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  @click="preventPropagation" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Anchor>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import LazyImage from './common/LazyImage.vue'
import SlickCarousel from '../components/common/SlickCarousel.vue'
import constants from './../../lib/constants'
import Anchor from '../components/common/Anchor.vue'

export default {
  components: { Anchor, LazyImage, SlickCarousel },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      vatIncluded: false,
      slickKey: uuidv4(),
      slickOptions: {
        infinite: true,
        autoplay: false,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false,
      },
    }
  },
  computed: {
    isElectric() {
      return this.item.fuelPreValue === constants.flexdrive.fuelType.electic
    },
    isPointer() {
      if (
        this.item.pricePerMonthInclVatInteger > 0 &&
        this.item.pricePerMonthInclVatInteger
      ) {
        return 'pointer'
      }
      return 'default'
    },
    isDisabled() {
      if (
        this.item.pricePerMonthInclVatInteger === 0 ||
        !this.item.pricePerMonthInclVatInteger
      ) {
        return true
      }
      return false
    },
    images() {
      const images = this.item.images
      if (!images.length) {
        return []
      }
      return images.map((x) => ({ url: x.url, alt: x.alt }))
    },
  },
  methods: {
    preventPropagation(event) {
      event.stopPropagation()
    },
  },
}
</script>
